import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { acceptInvitation, declineInvitation } from 'Actions/projectActions';
import { connect } from 'react-redux';
import AvatarUser from './components/AvatarUser/index';
import styled from 'styled-components';

const CustomGrid = styled(Grid)`
  min-width: 100%;
`;

class ProjectInvitationCard extends React.Component {
  onAcceptInvitation = () =>
    this.props.acceptInvitation(this.props.invitation.projectId);

  render() {
    return (
      <CustomGrid item xs={11}>
        <div className="ProjectInvitationCard bc-gray">
          <div className="invitationDetails">
            <AvatarUser
              user={this.props.invitation.invitedBy}
              className="mui-avatar u-mrg-r-10"
              imageId={this.props.invitation.projectCreatorProfileImageId}
            />
            <p className="lh-22 t-secondary-14 c-s-blue">
              <b className="c-blue-dark">{this.props.invitation.invitedBy} </b>
              invited you to join
              <br />
              the project
              <b className="c-blue-dark t-secondary-16">
                {' '}
                {this.props.invitation.projectName}{' '}
              </b>
              on
              <br />
              {/* <span>
                <b>Project number: </b>
                {this.props.invitation.uniqueProjectNumber}
              </span> */}
              <span>
                <b>Luminaire Broker</b>
              </span>
            </p>
          </div>
          <div className="invitationButtons u-mrg-top-10">
            <span
              onClick={() =>
                this.props.declineInvitation(this.props.invitation.projectId)
              }
              className="c-blue-2-light t-primary-16 t-weight-b pointer"
            >
              DECLINE
            </span>

            <Button
              onClick={this.onAcceptInvitation}
              className="u-mrg-left-30 t-primary-16 t-weight-b c-s-blue"
              variant="contained"
              color="primary"
            >
              ACCEPT
            </Button>
          </div>
        </div>
      </CustomGrid>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  declineInvitation: projectId => {
    dispatch(declineInvitation(projectId));
  },
  acceptInvitation: projectId => {
    dispatch(acceptInvitation(projectId));
  },
});
export default connect(null, mapDispatchToProps)(ProjectInvitationCard);
